import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Menu from '@/views/Menu.vue';
import Rules from '@/views/Rules.vue';
import Prizes from '@/views/Prizes.vue';
import Gallery from '@/views/Gallery.vue';
import GalleryItem from '@/views/GalleryItem.vue';
import About from '@/views/About.vue';
import Contest from '@/views/Contest.vue';
import ContestInstructions from '@/views/ContestInstructions.vue';
import ContestWinners from '@/views/ContestWinners.vue';
import ContestGame from '@/views/ContestGame.vue';
import ContestGame2 from '@/views/ContestGame2.vue';
import ContestGame3 from '@/views/ContestGame3.vue';
import ContestQuestion from '@/views/ContestQuestion.vue';
import ContestPersonal from '@/views/ContestPersonal.vue';
import ContestLegals from '@/views/ContestLegals.vue';
import ContestSubmit from '@/views/ContestSubmit.vue';
import ContestEnd from '@/views/ContestEnd.vue';

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    const viacomHeader = document.querySelector('.viacomRoot.ExternalHeader');
    const y = viacomHeader ? viacomHeader.clientHeight : 0;

    return { x: 0, y };
  },

  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu,
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules,
    },
    {
      path: '/prizes',
      name: 'prizes',
      component: Prizes,
    },
    // {
    //   path: '/gallery',
    //   name: 'gallery',
    //   component: Gallery,
    // },
    // {
    //   path: '/gallery-item',
    //   name: 'gallery item',
    //   component: GalleryItem,
    // },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/contest',
      component: Contest,
      children: [
        {
          path: '',
          redirect: 'winners',
        },
        {
          path: 'winners',
          name: 'contest winners',
          component: ContestWinners,
        },
        {
          path: 'instructions',
          name: 'contest instructions',
          component: ContestInstructions,
        },
        {
          path: 'game',
          name: 'contest game',
          component: ContestGame,
        },
        {
          path: 'game2',
          name: 'contest game 2',
          component: ContestGame2,
        },
        {
          path: 'game3',
          name: 'contest game 3',
          component: ContestGame3,
        },
        {
          path: 'question',
          name: 'contest question',
          component: ContestQuestion,
        },
        {
          path: 'personal',
          name: 'contest personal',
          component: ContestPersonal,
        },
        {
          path: 'legals',
          name: 'contest legals',
          component: ContestLegals,
        },
        {
          path: 'submit',
          name: 'contest submit',
          component: ContestSubmit,
        },
        {
          path: 'end',
          name: 'contest end',
          component: ContestEnd,
        },
      ],
    },
    {
      path: '*',
      // redirect: '/',
      redirect: '/contest',
    },
  ],
});
